export default "__VITE_ASSET__BkEWxanX__"